import React, { useEffect, useState } from "react";
import services from "../../services";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { MdDetails } from "react-icons/md";
import ComposeEmail from "../../common/ComposeModal";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import TablePagination from "../../common/TablePagination";
import { Tooltip } from "react-tooltip";
import axios from "axios";
import Select from "react-select";
import { filterSelectStyles } from "../../common/filterSelectStyles";

const getAvatarColor = () => 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)';

const ShowAllMail = ({ gmailUsers, ActionPage }) => {
    const [loading, setLoading] = useState(false);
    const [allDraft, setAllDraft] = useState();
    const [ModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [gmailMessageId, setGmailMessageId] = useState("")
    const [mailPage, setMailPage] = useState(ActionPage || 1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalMails, setTotalMails] = useState(0)
    const [selectedGmailUser, setSelectedGmailUser] = useState(gmailUsers?.[0]?.value);
    const [selectedMailType, setSelectedMailType] = useState("All Mails");
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");


    const navigate = useNavigate();

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
            setMailPage(1);
        }, 500);

        return () => clearTimeout(handler);
    }, [search]);

    const getDraft = async (signal) => {
        setLoading(true);
        try {
            const isSearching = !!debouncedSearch;
            const response = await services.email.GET_ALL_MAILS(
                selectedGmailUser,
                mailPage,
                10,
                debouncedSearch,
                signal,
                isSearching // pass falsepagination as true if searching
            );
            setTotalCount(response?.data?.pagination?.totalPages);
            setTotalMails(response?.data?.pagination?.totalRecords);
            setAllDraft(response?.data?.data);
            setLoading(false);
        } catch (error) {
            if (error.name === 'AbortError' || error.name === 'CanceledError') {
                console.log('Request canceled');
            } else {
                console.error(error);
                setLoading(false);
            }
        }
    };

    /*   useEffect(() => {
          const controller = new AbortController();
          if (selectedGmailUser) {
              getDraft(controller.signal);
          }
          return () => controller.abort();
      }, [mailPage, gmailUsers, selectedGmailUser, debouncedSearch]); */

    async function fetchSentEmails(page = 1, limit = 10, selectedGmailUser, debouncedSearch) {
        setLoading(true);
        try {
            const res = await services.email.GET_SENT_MAIL(page, limit, selectedGmailUser, debouncedSearch);
            setAllDraft(res?.data?.data);
            setTotalCount(res?.data?.pagination?.totalPages);
            setTotalMails(res?.data?.pagination?.totalCount);
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    }
    useEffect(() => {
        const controller = new AbortController();

        if (!selectedGmailUser) return;

        if (selectedMailType === "Sent") {
            fetchSentEmails(
                mailPage,
                10,
                selectedGmailUser,
                debouncedSearch,
                controller.signal
            );
        } else {
            getDraft(
                controller.signal,
                selectedGmailUser,
                debouncedSearch,
                mailPage
            );
        }

        return () => controller.abort();
    }, [
        selectedMailType,
        selectedGmailUser,
        mailPage,
        debouncedSearch
    ]);


    const handleEditClick = async (item) => {
        navigate(`/detail/${item?.id}`, {
            state: {
                selectedMail: item,
                deadlineDate: item?.deadlineDate,
                taskID: item.id,
                AllMail: true,
                type: 'Gmail',
                currentTask: item,
                boardId: item?.boardId,
                isMember: item?.isMember,
                parentOrigin: item?.parentOrigin,
                AllMailPage: mailPage
            },
        });
    };

    const updateStatusTaskMessage = async (gmailMessageId, status) => {
        try {
            const data = {
                messageRead: status,
            };
            const response = await services.email.EMAIL_UPDATEMESSAGE_READ(gmailMessageId, data);
            if (allDraft && Array.isArray(allDraft)) {
                const updatedDrafts = allDraft.map(draft =>
                    draft.gmailMessageId === gmailMessageId
                        ? { ...draft, messageRead: status }
                        : draft
                );
                setAllDraft(updatedDrafts);
            }
            if (selectedMailType === "Sent") {
                await fetchSentEmails(mailPage, 10, selectedGmailUser, debouncedSearch);
            } else {
                const controller = new AbortController();
                await getDraft(controller.signal);
            }
        } catch (error) {
            console.error('Error updating message read status:', error);
            toast.error('Failed to update message status');
        }
    };

    const dropDown = ["All Mails", "Sent"];

    return (
        <div className="h-[88vh] flex flex-col" style={{ background: '#f7f8fa' }}>
            {loading ? (
                <div className="flex-1 flex items-center justify-center text-[#8696a0] text-lg">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="flex-1 overflow-y-auto">

                    {/* ── Toolbar ── */}
                    <div className="allmail-toolbar">
                        <div className="allmail-search-wrap">
                            <svg className="allmail-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Search mail..."
                                className="allmail-search-input"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            {search && (
                                <button
                                    className="allmail-search-clear"
                                    onClick={() => setSearch("")}
                                    aria-label="Clear search"
                                >
                                    ×
                                </button>
                            )}
                        </div>

                        <div className="allmail-filters">
                            <Select
                                styles={filterSelectStyles}
                                isSearchable={false}
                                options={gmailUsers}
                                value={gmailUsers?.find(u => u.value === selectedGmailUser) || null}
                                onChange={(opt) => { setSelectedGmailUser(opt?.value); setMailPage(1); setSearch(""); }}
                            />
                            <Select
                                styles={filterSelectStyles}
                                isSearchable={false}
                                options={dropDown?.map(o => ({ value: o, label: o }))}
                                value={{ value: selectedMailType, label: selectedMailType }}
                                onChange={(opt) => { setSelectedMailType(opt?.value); setSearch(""); setMailPage(1); }}
                            />
                        </div>
                    </div>

                    {/* ── Mail Card ── */}
                    <div className="allmail-card">

                        {/* Card header */}
                        <div className="allmail-card-header">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <h2 className="allmail-card-title">Mails</h2>
                                <span className="allmail-count-badge">{totalMails}</span>
                            </div>
                        </div>

                        {/* Mail rows */}
                        <div className="allmail-list">
                            {allDraft && allDraft.map((draft) => {
                                const allowedLabels = ["inbox", "draft", "sent"];
                                const isUnread = draft.messageRead === "unread";
                                const senderName = draft.name || '';
                                const avatarColor = getAvatarColor(senderName);
                                const avatarLetter = senderName.charAt(0).toUpperCase() || '?';

                                const escapeHtml = (str = "") =>
                                    str
                                        .replace(/&/g, "&amp;")
                                        .replace(/</g, "&lt;")
                                        .replace(/>/g, "&gt;");

                                const sentByMail = escapeHtml(draft?.sender || draft?.sentBy);
                                const sentToMail = escapeHtml(draft?.receiver || draft?.sentTo);

                                const filteredLabels = draft.labels
                                    ?.toLowerCase()
                                    .split(",")
                                    .filter(label => allowedLabels.includes(label)) || [];

                                return (
                                    <div
                                        key={draft.id}
                                        className={`allmail-item group cursor-pointer${isUnread ? ' allmail-item--unread' : ''}`}
                                    >
                                        {/* Avatar with sender tooltip */}
                                        <div
                                            className="allmail-avatar"
                                            style={{ background: avatarColor }}
                                            data-tooltip-id="email-tooltip"
                                            data-tooltip-html={`
                                                <div style="display:flex;flex-direction:column;gap:4px;">
                                                    <div><strong>Sent By:</strong><span style="margin-left:6px;">${sentByMail}</span></div>
                                                    <div><strong>Sent To:</strong><span style="margin-left:6px;">${sentToMail}</span></div>
                                                </div>
                                            `}
                                        >
                                            {avatarLetter}
                                            <Tooltip
                                                id="email-tooltip"
                                                place="top"
                                                style={{
                                                    backgroundColor: "#fff",
                                                    color: "#1f2937",
                                                    border: "1px solid #e5e7eb",
                                                    fontSize: "12px",
                                                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)"
                                                }}
                                            />
                                        </div>

                                        {/* Sender name */}
                                        <div className="allmail-sender">
                                            <span className={`allmail-sender-name${isUnread ? ' allmail-sender-name--bold' : ''}`}>
                                                {draft.name}
                                            </span>
                                        </div>

                                        {/* Thread count */}
                                        {draft?.SubEmails?.length > 0 && (
                                            <span className="allmail-thread-count">
                                                {draft.SubEmails.length}
                                            </span>
                                        )}

                                        {/* Labels */}
                                        {filteredLabels.length > 0 && (
                                            <div className="allmail-labels">
                                                {filteredLabels.map(label => (
                                                    <span
                                                        key={label}
                                                        className={`allmail-label allmail-label--${label}`}
                                                    >
                                                        {label.charAt(0).toUpperCase() + label.slice(1)}
                                                    </span>
                                                ))}
                                            </div>
                                        )}

                                        {/* Subject */}
                                        <span
                                            className={`allmail-subject${isUnread ? ' allmail-subject--bold' : ''}`}
                                            data-tooltip-id="subject-tooltip"
                                            data-tooltip-content={draft.subject}
                                            onMouseEnter={(e) => {
                                                const target = e.currentTarget;
                                                if (target.scrollWidth <= target.clientWidth) {
                                                    target.removeAttribute('data-tooltip-id');
                                                } else {
                                                    target.setAttribute('data-tooltip-id', 'subject-tooltip');
                                                }
                                            }}
                                        >
                                            {draft.subject}
                                        </span>

                                        {/* Right meta */}
                                        <div className="allmail-meta">
                                            {/* Default view */}
                                            <div className="allmail-meta-default group-hover:hidden">
                                                {draft?.isTaskCreated && (
                                                    <span className="allmail-board-chip">
                                                        {draft?.Tasks?.[0]?.Board?.boardName}
                                                        {draft?.Tasks?.[0]?.BoardList?.coloum && (
                                                            <> → {draft?.Tasks?.[0]?.BoardList?.coloum}</>
                                                        )}
                                                    </span>
                                                )}
                                                <span className="allmail-date">
                                                    {moment(draft.createdAtEmail).format("MMM D, h:mm")}
                                                </span>
                                            </div>

                                            {/* Hover view */}
                                            <div className="allmail-actions hidden group-hover:flex">
                                                {draft?.isTaskCreated && (
                                                    <span className="allmail-board-chip">
                                                        {draft?.Tasks?.[0]?.Board?.boardName}
                                                        {draft?.Tasks?.[0]?.BoardList?.coloum && (
                                                            <> → {draft?.Tasks?.[0]?.BoardList?.coloum}</>
                                                        )}
                                                    </span>
                                                )}
                                                <button
                                                    className="allmail-action-btn"
                                                    title="View details"
                                                    onClick={() => {
                                                        handleEditClick(draft);
                                                        updateStatusTaskMessage(draft.gmailMessageId, 'read');
                                                    }}
                                                >
                                                    <MdDetails fontSize={18} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* ── Pagination ── */}
                    <div className="allmail-pagination">
                        <TablePagination
                            currentPage={mailPage}
                            totalPages={totalCount}
                            onPageChange={setMailPage}
                        />
                    </div>

                </div>
            )}
            <Tooltip id="subject-tooltip" placement="top" />
        </div>
    );
};

export default ShowAllMail;
